// HOME
const HOME = `/`;
export const HOME_PAGE_URI = `${HOME}`;

const AUTH= '/auth'
export const SIGN_IN_PAGE_URI = '/auth/sign-in'
export const SIGN_UP_PAGE_URI = '/auth/sign-up'
export const SIGN_IN_COR_ID_PAGE_URI = '/auth/corId-sign-in'
export const SIGN_IN_CREDENTIAL_PAGE_URI = '/auth/credential-sign-in'
export const SIGN_IN_ERROR_PAGE_URI = '/auth/error-sign-in'
